import { render, staticRenderFns } from "./PriceRegion.vue?vue&type=template&id=89047c6a&scoped=true"
import script from "./PriceRegion.vue?vue&type=script&lang=js"
export * from "./PriceRegion.vue?vue&type=script&lang=js"
import style0 from "./PriceRegion.vue?vue&type=style&index=0&id=89047c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89047c6a",
  null
  
)

export default component.exports